<template>
  <footer id="ftCont">
    <designTopMenu
      class="isntMainWrap"
      :phone="phone"
      :phoneForHref="phoneForHref"
      :inFooter="true"
    ></designTopMenu>
    <div class="isntMainWrap">
      <ul id="footerFiles">
        <li>
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 0H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM9.5 7.5C9.5 8.33 8.83 9 8 9H7v2H5.5V5H8c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V5H13c.83 0 1.5.67 1.5 1.5v3zm4-3H17v1h1.5V9H17v2h-1.5V5h3v1.5zM7 7.5h1v-1H7v1zM2 4H0v14a2 2 0 002 2h14v-2H2V4zm10 5.5h1v-3h-1v3z" fill="#fff"/></svg>
          <a href="https://finmoll.ru/backend/content/documents/rules_microloans" target="_blank">Правила предоставления микрозаймов</a>
        </li>
        <li>
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 0H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM9.5 7.5C9.5 8.33 8.83 9 8 9H7v2H5.5V5H8c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V5H13c.83 0 1.5.67 1.5 1.5v3zm4-3H17v1h1.5V9H17v2h-1.5V5h3v1.5zM7 7.5h1v-1H7v1zM2 4H0v14a2 2 0 002 2h14v-2H2V4zm10 5.5h1v-3h-1v3z" fill="#fff"/></svg>
          <a href="https://finmoll.ru/backend/content/documents/microloan_terms_conditions" target="_blank">Общие условия договора микрозайма</a>
        </li>
        <li>
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 0H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM9.5 7.5C9.5 8.33 8.83 9 8 9H7v2H5.5V5H8c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V5H13c.83 0 1.5.67 1.5 1.5v3zm4-3H17v1h1.5V9H17v2h-1.5V5h3v1.5zM7 7.5h1v-1H7v1zM2 4H0v14a2 2 0 002 2h14v-2H2V4zm10 5.5h1v-3h-1v3z" fill="#fff"/></svg>
          <a href="https://finmoll.ru/backend/content/documents/microloan_providing_info" target="_blank">Информация об условиях предоставления, использования и возврата потребительского займа</a>
        </li>
        <li>
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 0H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM9.5 7.5C9.5 8.33 8.83 9 8 9H7v2H5.5V5H8c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V5H13c.83 0 1.5.67 1.5 1.5v3zm4-3H17v1h1.5V9H17v2h-1.5V5h3v1.5zM7 7.5h1v-1H7v1zM2 4H0v14a2 2 0 002 2h14v-2H2V4zm10 5.5h1v-3h-1v3z" fill="#fff"/></svg>
          <a href="https://finmoll.ru/backend/content/documents/svedeniya_podlezashie_raskritiyu" target="_blank">Сведения, подлежащие раскрытию ООО МКК «ФИНМОЛЛ»</a>
        </li>
        <li>
          <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18 0H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2zM9.5 7.5C9.5 8.33 8.83 9 8 9H7v2H5.5V5H8c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V5H13c.83 0 1.5.67 1.5 1.5v3zm4-3H17v1h1.5V9H17v2h-1.5V5h3v1.5zM7 7.5h1v-1H7v1zM2 4H0v14a2 2 0 002 2h14v-2H2V4zm10 5.5h1v-3h-1v3z" fill="#fff"/></svg>
          <a href="https://finmoll.ru/upload/iblock/37e/politika-v-otnoshenii-obrabotki-pd_finmoll_1_.pdf" target="_blank">Политика в отношении обработки персональных данных</a>
        </li>
      </ul>
      <div id="importantDesc">
        <p>*ООО МКК «ФИНМОЛЛ» Сумма по одному договору займа от 35000 до 100000 рублей. Займы предоставляются на условиях платности, срочности и возвратности, сроком до 53 недель, процентные ставки по договорам займа составляют от 178,00% до 292,00% годовых в зависимости от вида займа и срока пользования денежными средствами, при этом диапазон значений полной стоимости займа (ПСК) составляет от 178,000% до 292,000% в соответствии с Информацией об условиях предоставления, использования и возврата потребительского микрозайма ООО МКК «ФИНМОЛЛ». Обязательные платные услуги отсутствуют. Ответственность за неисполнение или ненадлежащее исполнение обязательства (неустойка, пеня) отсутствует. Конкретные условия договора займа указываются в Индивидуальных условиях и согласуются сторонами до подписания Договора займа. ООО МКК «ФИНМОЛЛ» вправе отказать в предоставлении займа полностью или предложить иные условия заключения договора микрозайма до его фактического заключения. Требования к заемщикам: возраст от 18 до 70 лет. Гражданство РФ. Постоянная регистрация на территории РФ. Наличие контактного телефонного номера. ООО МКК «ФИНМОЛЛ». Регистрационный номер в государственном реестре МФО: 651403550005541. ОГРН 1117746509638. Юридический адрес: 630112, Новосибирская область, город Новосибирск, улица Фрунзе, дом 242, помещение 406.</p>
        <p>**Данный калькулятор носит исключительно демонстрационный характер, представленные в калькуляторе расчеты являются информационными и могут не соответствовать согласованным условиям договора займа. Все условия договора заёма подлежат согласованию при заключении договора займа в соответствии с Информацией об условиях предоставления, использования и возврата потребительского микрозайма ООО МКК «ФИНМОЛЛ».</p>
        <p class="fs14">ООО МКК «ФИНМОЛЛ» Общество с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ»</p>
        <p class="fs14">Юридический адрес: 630112, Россия, г. Новосибирск, ул. Фрунзе, д. 242, помещение 406 ОГРН:1117746509638</p>
        <p class="fs15">© {{dtNow}} Все права защищены</p>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
  name: "instfooter",
  props:{
    phone:{
      type:String,
      default(){
        return '';
      }
    },
    phoneForHref:{
      type:String,
      default(){
        return '';
      }
    },
  },
  data(){
    return {
      dtNow:'',
    }
  },
  mounted() {
    const dt = new Date();
    this.dtNow = dt.getFullYear();
  },
  components: {
    designTopMenu: () => import('@/components/inst/design/topMenu.vue'),
  }
}
</script>

<style scoped>
#ftCont{position: relative;}
footer{background: var(--color-black-type2);padding: var(--font-size-30) 0;}
#footerFiles{width:var(--block-width-with-padding-20);margin: 0 auto}
#footerFiles li{display: flex;align-items: flex-start;justify-content: flex-start;margin-bottom: var(--font-size-10)}
#footerFiles li svg{width: var(--font-size-20);height: var(--font-size-20);margin-right: var(--font-size-25)}
#footerFiles li a{color:white;font-family: 'Roboto';font-weight: 400;font-size: var(--font-size-16);display: block;width: calc(100% - var(--font-size-25)  - var(--font-size-20))}

#importantDesc{font-family: 'Roboto';font-weight: 400;font-size: var(--font-size-12);color:white;width:var(--block-width-with-padding-20);margin: 0 auto}
#importantDesc p{margin: var(--font-size-20) 0}
#importantDesc p.fs14{font-size: var(--font-size-14);}
#importantDesc p.fs15{font-size: var(--font-size-15);}

@media screen and (min-width: 760px) {
  #footerFiles{width: 100%;margin-top: var(--font-size-60)}
  #importantDesc{width: 100%}
}
</style>